import { ComponentStyleConfig } from '@chakra-ui/react';

export const Alert: ComponentStyleConfig = {
  baseStyle: {
    container: {
      minHeight: 49,
      borderRadius: 6,
      padding: '8px 16px',
      minWidth: 180,
      maxWidth: 400,
      svg: {
        marginLeft: 'auto',
      },
    },
    title: {
      color: 'M.10',
      fontSize: 'sm',
    },
    description: {
      color: 'M.10',
      fontSize: 'xxs',
      fontWeight: 400,
    },
  },
  variants: {
    solid: {
      container: {
        bg: 'M.70',
      },
    },
  },
  defaultProps: {
    variant: 'solid',
  },
};
